import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { AddUserFormModal } from "./AddUserForm";

export const AddNewBar = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <AddUserFormModal openModal={openModal} setOpenModal={setOpenModal} />

      <Box component="section" flex={1} textAlign={"right"}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenModal(true)}
        >
          Add New
        </Button>
      </Box>
    </>
  );
};
